import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Para qué edades sirve?',
  answer: 'De 3 a 10 años. Las actividades están diseñadas para adaptarse al nivel de desarrollo de cada niño en este rango de edad.'
}, {
  question: '¿Necesito experiencia para usarlo?',
  answer: 'No. Está diseñado para que cualquier mamá o docente pueda implementarlo de manera fácil y rápida, sin necesidad de conocimientos previos.'
}, {
  question: '¿Es físico o digital?',
  answer: 'Es un producto 100% digital e imprimible. Recibirás los archivos en formato PDF listos para descargar y usar.'
}, {
  question: '¿Cuándo recibo el acceso?',
  answer: 'Inmediatamente después de confirmar tu compra, recibirás un correo electrónico con el enlace para descargar todo el material.'
}, {
  question: '¿Cuántas veces puedo imprimirlo?',
  answer: 'Las veces que necesites para uso personal. Podés imprimir las hojas de práctica todas las veces que tu hijo lo requiera.'
}, {
  question: '¿Sirve para docentes?',
  answer: 'Sí, fue diseñado tanto para el hogar como para el aula. Muchos docentes lo utilizan como material de apoyo en sus clases.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-slate-50" data-id="element-19">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20">
        <div className="text-center mb-16" data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-extrabold text-brand-dark mb-4" data-id="element-22">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-brand-text" data-id="element-23">
            Resolvemos todas tus dudas para que compres con total seguridad.
          </p>
        </div>

        <div className="space-y-4" data-id="element-24">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-25">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-26">
                <span className="font-bold text-brand-dark text-lg pr-4" data-id="element-27">
                  {faq.question}
                </span>
                <ChevronDown className={`text-brand-primary transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-28" />
              </button>

              <AnimatePresence data-id="element-29">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-30">
                    <div className="px-6 pb-5 text-brand-text" data-id="element-31">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}